import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceTypeMultipleSelectSectionCtrl implements IController {
  serviceTypes: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  /* @ngInject */
  constructor(private deliveriesConstants) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.deliveriesConstants.serviceTypes;
    }
  }

  $onChanges(changes) {
    if (changes.serviceTypes) {
      this.selectedKeys = [];
      _.forEach(this.serviceTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      serviceTypes: isSelected ? _.concat(this.serviceTypes, [option]) :
        _.filter(this.serviceTypes, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({serviceTypes: []});
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTypeMultipleSelectSection', {
    bindings: {
      serviceTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./service-type-multiple-select-section.html').default,
    controller: ServiceTypeMultipleSelectSectionCtrl
  });
